import { useEffect, useRef } from 'react';

// ref: https://overreacted.io/making-setinterval-declarative-with-react-hooks/
// HUGE THANKS to Dan Abramov 🙌
export function useInterval(callback: () => void, delay: number | null) {
    const savedCallback = useRef<any>();

    // Remember the latest callback
    useEffect(() => {
        savedCallback.current = callback;
    }, [callback]);

    // Set up the interval
    useEffect(() => {
        function tick() {
            savedCallback.current();
        }
        if (delay !== null) {
            const id = setInterval(tick, delay);
            return () => {
                console.log('Clearing interval', id);
                clearInterval(id);
            }
        }
    }, [delay]);
}

export const usePrevious = (value: any) => {
    const ref = useRef();
    useEffect(() => {
        ref.current = value;
    }, [value]);

    return ref.current;
}
